import React from "react";
import Context from "../../../../../Context";
import { Modal } from "react-bootstrap";
import Blocker from "../../../../Misc/Blocker";
import InputForm from "../../../../Misc/InputForm";

export default class WorkflowTransitions extends React.Component {
  static contextType = Context;

  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      activeItem: false,
      add: false,
      edit: false,
      security: false,
      all: false,
      items: {},
      states: {},
    };
    this.apiPath = "/workflow/transition";
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    if (this.props.classId) {
      if (!this.props.stateId || !this.props.actionId) return;
      this.setState({ pending: true });

      let search = [];

      if (this.props.stateId && !this.state.all)
        search.push({
          field: "state",
          compare: "EQL",
          value: this.props.stateId,
        });

      if (this.props.actionId && !this.state.all)
        search.push({
          field: "method",
          compare: "EQL",
          value: this.props.actionId,
        });

      let items = await this.context.api.qo(this.apiPath + "/list", {
        search,
      });

      let states = await this.context.api.qo("/workflow/state/list", {
        search: [{ field: "class", compare: "EQL", value: this.props.classId }],
        orderby: ["sequence ASC"],
      });

      this.setState({ pending: false, items, states }, () =>
        this.select(this.state.activeItem)
      );
    }
  };

  select = (id = false) => {
    if (!id) {
      for (let nid in this.state.items) {
        id = nid;
        break;
      }
    }

    this.setState({ activeItem: String(id) });
    let activeItem = this.state.items[String(id)] || {};
    this.props.onChange(activeItem);
  };

  save = async (data) => {
    let activeItem = this.state.items[this.state.activeItem];
    if (this.state.edit) data.id = activeItem["id"];

    data.state = this.props.stateId;
    data.method = this.props.actionId;

    if (!data.sequence) delete data.sequence;

    this.setState({ pending: true });
    let result = await this.context.api.q(this.apiPath + "/set", data);
    if (result !== false) {
      this.context.toast(`${data.label}: Изменения сохранены`, "success");
      await this.load();
      this.setState({ edit: false, add: false, security: false });
      if (result["id"]) this.select(result["id"]);
    } else {
      this.context.toast(
        `${data.label}: Не удалось сохранить изменения`,
        "error"
      );
    }
    this.setState({ pending: false });
  };

  deleteClick = (item = {}) => {
    this.context
      .ask(
        `Вы действительно хотите удалить  ${item.label} `,
        "Удаление",
        "question"
      )
      .then((answer) => {
        if (answer.value) {
          this.delete(item);
        }
      });
  };

  delete = async (item = {}) => {
    this.setState({ pending: true });

    let result = await this.context.api.q(this.apiPath + "/delete", {
      id: item.id,
    });
    if (result !== false) {
      this.context.toast(`${item.label}: элемент удален`, "success");
      this.select();
      this.load();
    } else {
      this.context.toast(`${item.label}: Не удалось удалить элемент`, "error");
    }

    this.setState({ pending: false });
  };

  toggleAll = () => {
    this.setState(
      (state) => {
        return { all: !state.all, activeItem: false };
      },
      () => this.load()
    );
  };

  renderPath() {
    let activeItem = this.state.items[this.state.activeItem] || {};
    let classlabel = activeItem.classlabel || this.props.stateItem.classlabel;
    let statelabel = this.props.stateItem.label;
    let actionLabel = this.props.actionItem.label;
    return (
      <div className="alert bg-light">
        {classlabel}
        <span className="fa fa-long-arrow-right mx-2 text-muted"></span>
        {statelabel}
        <span className="fa fa-long-arrow-right mx-2 text-muted"></span>
        <b>{actionLabel}</b>
      </div>
    );
  }

  renderItems() {
    if (Object.keys(this.state.items).length === 0 && !this.state.pending)
      return (
        <tr>
          <td colSpan="10" className="p-10 text-center">
            Список пуст.
            <span
              title="Добавить"
              onClick={() => this.setState({ add: true, activeItem: false })}
              className="ml-2 cursor-pointer text-muted text-hover-primary"
            >
              Добавить элемент
            </span>
          </td>
        </tr>
      );
    return (
      <>
        {Object.entries(this.state.items).map(([id, item]) => (
          <tr
            key={id}
            onClick={() => this.select(id)}
            className={`cursor-pointer  ${
              this.state.activeItem === String(id)
                ? "bg-light-primary"
                : "bg-hover-light"
            }`}
          >
            <td width="27%">
              <span className="text-muted font-size-sm">
                {item.statecode}:{" "}
              </span>
              {item.statelabel}
            </td>

            <td width="27%">
              <span className="text-muted font-size-sm">
                {item.actioncode}:{" "}
              </span>
              {item.actionname}
            </td>

            <td width="27%">
              <span className="text-muted font-size-sm">
                {item.newstatecode}:{" "}
              </span>
              {item.newstatelabel}
            </td>

            <td className="text-right text-nowrap">
              <span
                title="Изменить"
                onClick={() => this.setState({ edit: true, activeItem: id })}
                className="flaticon2-edit px-2 align-middle text-muted  cursor-pointer  text-hover-dark"
              ></span>

              <span
                title="Удалить"
                onClick={() => this.deleteClick(item)}
                className="flaticon2-rubbish-bin px-2 align-middle cursor-pointer text-muted text-hover-danger"
              ></span>
            </td>
          </tr>
        ))}
      </>
    );
  }

  render() {
    if (!this.props.stateId || !this.props.actionId) return null;
    let activeItem = this.state.items[this.state.activeItem] || {};
    return (
      <>
        <div>
          <Blocker on={this.state.pending}>
            {this.props.classId ? (
              <div className="table-responsive">
                <table className="table w-100">
                  <thead>
                    <tr>
                      <td>Состояние</td>

                      <td>Операция</td>

                      <td>Новое состояние</td>
                      <td className="text-right">
                        <span
                          title="Добавить"
                          onClick={() =>
                            this.setState({ add: true, activeItem: false })
                          }
                          className=" flaticon2-add-1 px-2 align-middle cursor-pointer text-muted text-hover-primary"
                        ></span>
                      </td>
                    </tr>
                  </thead>
                  <tbody>{this.renderItems()}</tbody>
                </table>
              </div>
            ) : null}
          </Blocker>
          {this.state.add || this.state.edit ? (
            <Modal
              show={true}
              onHide={() =>
                this.setState({ add: false, edit: false, security: false })
              }
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {this.state.edit
                    ? "Редактирование элемента"
                    : "Добавление элемента"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Blocker on={this.state.pending}>
                  {this.renderPath()}
                  <InputForm
                    fields={{
                      newstate: {
                        title: "Новое состояние",
                        type: "select",
                        values: this.state.states,
                        valuesNameKey: "label",
                        validate: true,
                        error: false,
                        default: "",
                        col: "12",
                      },
                    }}
                    data={activeItem}
                    key={this.state.add ? "add" : activeItem["id"]}
                    onSubmit={this.save}
                    onCancell={() =>
                      this.setState({
                        add: false,
                        edit: false,
                        security: false,
                      })
                    }
                  />
                </Blocker>
              </Modal.Body>
            </Modal>
          ) : null}
          {this.state.security ? (
            <Modal
              show={true}
              onHide={() =>
                this.setState({ add: false, edit: false, security: false })
              }
            >
              <Modal.Header closeButton>
                <Modal.Title>Безопасность</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Blocker on={this.state.pending}>
                  Найстройки безопасности времененно недоступны
                </Blocker>
              </Modal.Body>
            </Modal>
          ) : null}
        </div>
      </>
    );
  }
}
